import TextComboInput from "@shared/v2/TextComboInput";
import Tooltip from "@shared/v2/Tooltip";
import { CircleInfoSolidV6 } from "@shared/v2/Icomoon";
import { SettingsSection } from "./types";
import Typography from "@shared/v2/Typography";

const TransactionDataSettings = ({ onChange, productionGoals }: SettingsSection) => (
  <div className="tw-flex tw-flex-col tw-gap-[24px]">
    {/* @ts-expect-error props */}
    <Typography>
      Team defaults for <b>Transaction Data</b> are used to provide new agents with a baseline set of values
      when they are setting their <b>Production Goals</b> via Business Planning (Help Me Set My Goals)
    </Typography>

    <div className="tw-flex tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        leading="$"
        label="Avg. Sale Price"
        name="avgSalePrice"
        error={productionGoals.errors.avgSalePrice}
        value={productionGoals.goals.avgSalePrice}
        onChange={onChange}
      />
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        trailing="%"
        label="Avg. Commission"
        name="avgCommission"
        error={productionGoals.errors.avgCommission}
        value={productionGoals.goals.avgCommission}
        onChange={onChange}
      />
    </div>
    <div className="tw-flex tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        trailing="%"
        label="Seller Commission Split w/ Team"
        name="sellerCommissionSplit"
        error={productionGoals.errors.sellerCommissionSplit}
        value={productionGoals.goals.sellerCommissionSplit}
        onChange={onChange}
      />
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        trailing="%"
        label="Buyer Commission Split w/ Team"
        name="buyerCommissionSplit"
        error={productionGoals.errors.buyerCommissionSplit}
        value={productionGoals.goals.buyerCommissionSplit}
        onChange={onChange}
      />
    </div>
    <div className="tw-flex tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        trailing="%"
        label="Pending to Closed Ratio"
        name="pendingToCloseRatio"
        error={productionGoals.errors.pendingToCloseRatio}
        value={productionGoals.goals.pendingToCloseRatio}
        onChange={onChange}
      />
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        trailing="%"
        label={
          <span className="tw-flex tw-items-center tw-gap-[4px]">
            Seller to Total Closings Ratio
            <Tooltip
              // @ts-expect-error props
              trigger={<CircleInfoSolidV6 />}
              content="The percentage of buyer and seller closings that were sellers"
              innerClassName="tw-max-w-[230px]"
            />
          </span>
        }
        name="sellerToTotalClosingsRatio"
        error={productionGoals.errors.sellerToTotalClosingsRatio}
        value={productionGoals.goals.sellerToTotalClosingsRatio}
        onChange={onChange}
      />
    </div>
  </div>
);

export default TransactionDataSettings;
